import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { createStore as reduxCreateStore, compose, applyMiddleware } from 'redux';
import rootReducer from './';
import { SiteProvider } from './SiteContext';

const middlewares: any[] = [];

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// if REDUX_DEVTOOLS is running, feed it with info.
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
const enhancers = composeEnhancers(applyMiddleware(...middlewares));

const createStore = () => reduxCreateStore(rootReducer, undefined, enhancers);

interface WrapperProps {
  element: ReactNode;
}

const ReduxWrapper = ({ element }: WrapperProps) => (
  <Provider store={createStore()}>
    <SiteProvider>{element}</SiteProvider>
  </Provider>
);

export default ReduxWrapper;

